export default "__VITE_ASSET__CQP7PPKT__"